module.exports = function() {
  return new Worker(__webpack_public_path__ + "8f7f97cdeb7920cdf89d.worker.js");
};